export default class CardMedia extends HTMLElement
{
    constructor()
    {
        super();
    }

    static get observedAttributes()
    {
        return ['card-media-data', 'stylesheet', 'translations'];
    }

    attributeChangedCallback(name, oldValue, newValue)
    {
        if (this.shadowRoot) {
            this.shadowRoot.querySelector(`[name="${name}"]`).innerHTML = this[name];
        }
    }

    connectedCallback()
    {
        let shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#card-media');
        const instance = t.content.cloneNode(true);

        let cardMediaDataJson = JSON.parse(this.cardMediaData);
        let translations = JSON.parse(this.translations);

        let cardMedia = instance.querySelector('[name="card-media"]');

        cardMedia.setAttribute("class", cardMediaDataJson.cardMediaClass);
        if (cardMediaDataJson.cardMediaBody) {
            if (cardMediaDataJson.cardMediaBody.bodyBoldText) {
                instance.querySelector('[name="card-media-body-bold-text"]').classList.add(cardMediaDataJson.cardMediaBody.bodyBoldText, 'pb-2');
            }
            if (cardMediaDataJson.cardMediaBody.bodyText) {
                instance.querySelector('[name="card-media-body-text"]').classList.add(cardMediaDataJson.cardMediaBody.bodyText);
            }
        }

        if (cardMediaDataJson.cardMediaHeader.icon != 'null') {
            instance.querySelector('[name="card-media-header-icon"]').setAttribute("class", cardMediaDataJson.cardMediaHeader.icon);
        }else {
            instance.querySelector('[name="card-media-header-img"]').src = cardMediaDataJson.cardMediaHeader.img;
            instance.querySelector('[name="card-media-header-img"]').setAttribute("class", cardMediaDataJson.cardMediaHeader.imgClass);
        }

        if (cardMediaDataJson.cardMediaHeader.img === 'null'){
            instance.querySelector('[name="card-media-header-img"]').setAttribute('class', 'hidden');
        }

        if(typeof translations.cardMediaBodyBoldText != "undefined" ) {
            instance.querySelector('[name="card-media-body-bold-text"]').innerHTML = translations.cardMediaBodyBoldText;
        }
        if(typeof translations.cardMediaBodyText != "undefined" ) {
            instance.querySelector('[name="card-media-body-text"]').innerHTML = translations.cardMediaBodyText;
        }
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        shadowRoot.appendChild(instance);
    }

    get cardMediaData()
    {
        return this.getAttribute('card-media-data');
    }

    get stylesheet()
    {
        return this.getAttribute('stylesheet');
    }

    get translations()
    {
        return this.getAttribute('translations');
    }
}